import Model from '@/models/Model';

export default class Product extends Model {
    get route () {
        return 'products';
    }

    static get className () {
        return 'Product';
    }
}
